/**
 * The product every announcement names, on every host (Matt, 2026-10-27, docs/42 §4). An
 * announcement says "Steward" even under a firm's brand, as the app already does elsewhere in
 * white-label scenarios. The `{product}` token is still accepted and always renders as this value.
 * Single source: the page intro, the title and body substitution, and the popup all import it.
 * A firm's own product name is deliberately NOT used here; `hideOnBrandedHosts` is the control for
 * an item that must not appear on firm hosts at all.
 */
export const ANNOUNCEMENT_PRODUCT_NAME = 'Steward';
